import './App.css';
import Weather from './components/Weather.js'

function App() {
  return (
    <div className="App">
      <Weather />
    </div>
  );
}

export default App;
